var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMenuClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#83868A",
  d: "m8.736 7.341 5.669-5.659A.978.978 0 1 0 13.02.297L7.35 5.966 1.682.287a.99.99 0 0 0-1.395 0 .99.99 0 0 0 0 1.395l5.669 5.67L.287 13.01a.978.978 0 0 0 .698 1.67c.255 0 .5-.098.697-.285l5.67-5.669 5.668 5.67a.97.97 0 0 0 .697.284c.256 0 .501-.098.698-.285a.98.98 0 0 0 0-1.385L8.746 7.34z"
})));
export default SvgIcMenuClose;